import { createContext, useContext, useMemo, useState } from 'react';

const SidebarLayoutContext = createContext({ sidebarWidth: 0, setSidebarWidth: () => {} });

const SidebarLayoutProvider = ({ children }) => {
    const [sidebarWidth, setSidebarWidth] = useState(0);
    const value = useMemo(() => ({ sidebarWidth, setSidebarWidth }), [sidebarWidth]);

    return <SidebarLayoutContext.Provider value={value}>{children}</SidebarLayoutContext.Provider>;
};

const useSidebarLayout = () => useContext(SidebarLayoutContext);

export { useSidebarLayout };
export default SidebarLayoutProvider;
